import { Component } from '@angular/core';
import { ButtonType } from '../../../../../../shared/store/subheader/type';
import { Observable } from 'rxjs';
import {
  ContactDetailModel,
  ContactModel,
} from '../../../../../../shared/store/contact/types';
import { ContactService } from '../../../../../../shared/store/contact/contact.service';

@Component({
  selector: 'app-contact-details-leads',
  templateUrl: './contact-details-leads.component.html',
  styleUrl: './contact-details-leads.component.scss',
  standalone: false,
})
export class ContactDetailsLeadsComponent {
  contactDetail$: Observable<ContactDetailModel>;

  protected readonly ButtonType = ButtonType;

  constructor(private readonly contactService: ContactService) {
    this.contactDetail$ = this.contactService.getById.value$;
  }
}
